<template>
  <el-form-item :label="$t('privateNetInstance.agent.status') | withColon">
    <span>{{ displayStatus }}</span>
    <el-tooltip placement="right" v-if="isDataDef">
      <el-button class="icon">?</el-button>
      <template slot="content">
        <i18n tag="span" path="privateNetInstance.agent.installWarn">
          <a v-bind:href="Config.AGENT_URL" target="_blank" place="link">{{
            $t('privateNetInstance.agent.guide')
            }}</a>
        </i18n>
      </template>
    </el-tooltip>
  </el-form-item>
</template>

<script>
export default {
  props: {
    t: {
      type: Function,
      requires: true
    },
    data: {
      type: Boolean,
      requires: true
    }
  },
  computed: {
    isDataDef() {
      return typeof this.data !== 'undefined';
    },
    displayStatus() {
      return !this.isDataDef
        ? '--'
        : this.data
          ? this.$t('privateNetInstance.agent.normal')
          : this.$t('privateNetInstance.agent.abnormal');
    }
  }
}
</script>

<style lang="scss" scoped>
.icon {
  $color1: #2C68FF;
  $dia: 12px;

  min-width: 0;
  min-height: 0;
  width: $dia;
  height: $dia;
  border: 1px solid $color1;
  border-radius: 50%;
  color: $color1;
  display: inline-block;
  line-height: $dia - 2px;
  text-align: center;
  font-size: 10px;
  margin-left: 5px;
  padding: 0;
  font-family: sans-serif;
  margin-top: 8px;
}

a {
    color: #2C68FF;
  }
</style>



// WEBPACK FOOTER //
// src/components/privateNetInstance/AgentStatus.vue